<template>
    <transition name="slide-fade">
        <div class="dialog-view" v-if="dialogVisible" ref="modal">     
            <div class="u-window m-invite-modal">           
                <div class="u-btn close" @click="destroyElement"></div>
                <div class="dialog-wrapper">
                    <h5 class="title t-apply"></h5>
                    <div class="dialog-body">
                        <div class="share-text">
                            <p>请确认是否接受来自<b>{{ player_data.nickName }}</b>的助力邀请。</p>
                        </div>

                        <p class="notice">活动期间，同一玩家只能助力一次。</p>

                    </div>
    
                    <div class="u-ctrl">
                        <div class="u-btn apply" @click="apply"></div>
                        <div class="u-btn cancel" @click="destroyElement"></div>
                    </div>
                                      
                </div>         
            </div>
            <div class="u-mask"></div>
        </div>
    </transition>      
 </template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            code : '',
            player_data : '',
            team_switch : false,
            error_text : '请稍后再试',
            giftList : [
                [{ giftId : 'AM99', sendNum : 1 },{ giftId : 'F887', sendNum : 200 },{ giftId : 'MG50', sendNum : 1000 },{ giftId : '1', sendNum : 600 },],
                [{ giftId : 'MG50', sendNum : 500 },{ giftId : 'LP98', sendNum : 1 },{ giftId : 'F887', sendNum : 300 },{ giftId : 'LE96', sendNum : 10 },{ giftId : 'AN07', sendNum : 1 },],
            ],
            mode : 1,            
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
        this.render();
    },  
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$clear_share();
            localStorage.setItem('share', '');            
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        render() {
            var _this = this;
            this.$axios.get(ajax_url_map.invite_info,{
                params : {
                    code : this.code,
                }
            })
            .then(res => {
                this.player_data = res.data;
            },rej => {
                //this.destroyElement();
                //this.$toast('请稍后再试')
                this.team_switch = true;
                this.error_text = rej.message;
                this.$toast(rej.message);            
            });
        },
        apply (){

            if(!this.$store.state.login){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.zid){
                this.destroyElement();
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            this.apply_team();
        },
        apply_team (){
            this.$axios.post(ajax_url_map.apply_invite,{
                code : this.code,
            })
            .then(
                res => {
                    //this.destroyElement();
                    this.check = true;
                    this.$toast('助力成功');
                    this.destroyElement();
                    this.$clear_share();
                    localStorage.setItem('share', '');
                },
                rej => {
                    let text = rej.code == 1015 ? '无法助力自己' : rej.message;
                    this.destroyElement();
                    this.$toast(text);
                    this.$clear_share();
                    localStorage.setItem('share', '');
                }
            );
        },                
    },
}
</script>

<style scoped>
/* share */
.m-invite-modal {
    position: relative;
    width: 629px;
    height: 329px;
    font-size: 22px;
    color: #47505a;
    background-image: url(~@/assets/images/modal/bg-modal-copy.png);
}

.t-apply{
    width: 516px;
    height: 55px;
    margin: 0 auto 0;
    background-image: url(~@/assets/images/modal/title-webshare--apply.png);
}

.dialog-wrapper{
    /* padding: 90px 38px 0; */
}

.share-text{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 90px;
}

.share-text b{
    padding: 0 10px;
    word-break: break-all;
    color: #49392e;
}

.notice{
    text-align: center;
    font-size: 16px;
    color: #bd4a4a;
    margin-top: 16px;
}

.u-ctrl{
    position: absolute;
    left: 50%;
    bottom: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translateX(-50%);
}

.u-ctrl .u-btn.apply{
    width: 239px;
    height: 84px;
    margin: 0 14px 0;
    background-image: url(~@/assets/images/modal/btn-ok.png);    
}

.u-ctrl .u-btn.cancel{
    width: 239px;
    height: 84px;
    margin: 0 14px 0;
    background-image: url(~@/assets/images/modal/btn-cancel.png);    
}

.u-ctrl .u-btn.ok{
    width: 239px;
    height: 84px;
    margin: 0 14px 0;
    background-image: url(~@/assets/images/modal/btn-know.png);    
}

.reward-view{
    display: flex;
    justify-content: space-between;
    padding: 0 100px;
    margin: 20px 0 20px;
}

.reward-item{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 104px;
    height: 104px;
    background-image: url(~@/assets/images/modal/bg-item.png);   
}

.r-wrapper{
    width: 69px;
    height: 69px;
}

.r-wrapper>.pic{
    width: 100%;
    height: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/WebApply/inviteApply.vue